<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :key="tableKey"
        :page.sync="page"
        :search.sync="search"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
        @search-change="searchChange"
      >
        <template slot="goSoilTypeSearchLabel">
          <div class="search-label">出场签单:</div>
          <div class="search-desc">(土质)</div>
        </template>
        <template slot="inShiftTimeSearchLabel">
          <div class="search-label">班次时间:</div>
          <div class="search-desc">(挖机)</div>
        </template>
        <template slot="goShiftTimeSearchLabel">
          <div class="search-label">班次时间:</div>
          <div class="search-desc">(出场)</div>
        </template>
        <template slot="goDatetimeSearchLabel">
          <div class="search-label">签单时间:</div>
          <div class="search-desc">(出场)</div>
        </template>
        <template slot="inDatetimeSearchLabel">
          <div class="search-label">签单时间:</div>
          <div class="search-desc">(挖机)</div>
        </template>

        <template slot="inPcRemarkSearchLabel">
          <div class="search-label">备注:</div>
          <div class="search-desc">(PC后台)</div>
        </template>
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              v-if="permissions['chain:companywaybill3:excel']"
              style="margin-right: 20px; margin-bottom: 0"
              @click="exOutExcel"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>

            <div class="expand" @click="expandSearch">
              <span v-if="isExpand == true"
                >收起 <i class="el-icon-arrow-up"></i
              ></span>
              <span v-if="isExpand == false"
                >展开 <i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </div>
        </template>
        <template slot="settleCardNoSearch" slot-scope="{ row }">
          <tags v-model="statements"></tags>
        </template>
        <template slot="inPicture" slot-scope="{ row }">
          <el-image
            v-if="row.inPicture"
            style="width: 20px; height: 20px"
            :src="filterImg(row.inPicture)"
            :preview-src-list="filterImgs(row.inPicture)"
          >
          </el-image>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="goPicture" slot-scope="{ row }">
          <el-image
            v-if="row.goPicture"
            style="width: 20px; height: 20px"
            :src="filterImg(row.goPicture)"
            :preview-src-list="filterImgs(row.goPicture)"
          >
          </el-image>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="entrancePictureForm" slot-scope="{ row }">
          <span v-if="row.entrancePicture">
            <el-tooltip
              class="item"
              effect="dark"
              content="此处只显示一张，有多张请点击图片预览"
              placement="top-start"
            >
              <el-image
                style="width: 20px; height: 20px"
                :src="filterImg(row.entrancePicture)"
                :preview-src-list="filterImgs(row.entrancePicture)"
              >
              </el-image>
            </el-tooltip>
          </span>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="inPictureForm" slot-scope="{ row }">
          <span v-if="row.inPicture">
            <el-tooltip
              class="item"
              effect="dark"
              content="此处只显示一张，有多张请点击图片预览"
              placement="top-start"
            >
              <el-image
                style="width: 50px; height: 50px"
                :src="filterImg(row.inPicture)"
                :preview-src-list="filterImgs(row.inPicture)"
              >
              </el-image>
            </el-tooltip>
          </span>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="goPictureForm" slot-scope="{ row }">
          <span v-if="row.goPicture">
            <el-tooltip
              class="item"
              effect="dark"
              content="此处只显示一张，有多张请点击图片预览"
              placement="top-start"
            >
              <el-image
                style="width: 50px; height: 50px"
                :src="filterImg(row.goPicture)"
                :preview-src-list="filterImgs(row.goPicture)"
              >
              </el-image>
            </el-tooltip>
            <span v-if="filterImgs(row.goPicture).length > 1"
              >多张图片点击图片进行预览</span
            >
          </span>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="ticketImgForm" slot-scope="{ row }">
          <span v-if="row.ticketImg">
            <el-tooltip
              class="item"
              effect="dark"
              content="此处只显示一张，有多张请点击图片预览"
              placement="top-start"
            >
              <el-image
                style="width: 50px; height: 50px"
                :src="filterImg(row.ticketImg)"
                :preview-src-list="filterImgs(row.ticketImg)"
              >
              </el-image>
            </el-tooltip>
            <span v-if="filterImgs(row.ticketImg).length > 1"
              >多张图片点击图片进行预览</span
            >
          </span>
          <span v-else>暂无图片信息</span>
        </template>
        <template slot="menu" slot-scope="scope" class="menuSlot">
          <el-button
            type="text"
            v-if="permissions['chain:companywaybill3:get']"
            size="small"
            plain
            @click="viewInfo(scope.row, scope.index)"
          >
            详情</el-button
          >
          <el-button
            type="text"
            v-if="permissions['chain:companywaybill3:remark']"
            size="small"
            plain
            @click="setRemark(scope.row, scope.index)"
          >
            设置PC后台备注</el-button
          >
          <el-button
            size="small"
            type="text"
            plain
            v-if="permissions['chain:ledgerDig:setLoadCarPrice']"
            @click="batchSetLoadCarPrice(scope.row, scope.index)"
          >
            设置装车价
          </el-button>
        </template>

        <template slot="menuLeft" slot-scope="{ row }">
          <div class="checked">
            <el-checkbox
              :value="multipleSelection.length > 0"
              @change="changeAll"
              style="margin-right: 8px"
            ></el-checkbox>
            已选<span> {{ multipleSelection.length }} </span>个
          </div>
          <!-- <el-button
            icon="el-icon-download"
            v-if="permissions['chain:companywaybill3:excel']"
            size="small"
            :loading="btnLoading"
            type="primary"
            @click="exOutExcel"
          >
            导出
          </el-button> -->
          <el-button
            v-if="permissions['chain:companywaybill3:remark']"
            size="mini"
            :disabled="multipleSelection.length == 0"
            @click="setRemark('')"
          >
            批量设置PC后台备注
          </el-button>
          <!-- v-if="permissions['chain:ledgerDig:setLoadCarPrice']" -->

          <el-button
            size="mini"
            v-if="permissions['chain:ledgerDig:setLoadCarPrice']"
            :disabled="multipleSelection.length == 0"
            @click="batchSetLoadCarPrice('')"
          >
            批量设置装车价
          </el-button>
        </template>
      </avue-crud>

      <!-- 设置PC备注 -->
      <el-dialog
        title="设置PC备注"
        width="480px"
        custom-class="pc-dialog"
        :visible.sync="pcRemarkVisible"
      >
        <el-form
          :model="pcRemarkForm"
          :rules="pcRemarkRules"
          ref="pcRemarkForm"
        >
          <el-form-item prop="remark">
            <el-input
              type="textarea"
              v-model="pcRemarkForm.remark"
              placeholder="请输入PC备注"
              maxlength="100"
              show-word-limit
              rows="4"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pcRemarkVisible = false">取 消</el-button>
          <el-button type="primary" @click="editPcRemark('pcRemarkForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 设置装车价 -->
      <el-dialog
        title="设置装车价"
        width="480px"
        custom-class="pc-dialog"
        :visible.sync="loadingPriceVisible"
      >
        <el-form
          :model="loadingPriceForm"
          :rules="loadingPriceRules"
          ref="loadingPriceForm"
        >
          <el-form-item prop="price">
            <el-input
              placeholder="请输入装车价"
              type="number"
              v-model="loadingPriceForm.price"
            >
              <template slot="prepend">￥</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="loadingPriceVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="batchUpdateInPreparePrice('loadingPriceForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
       <!-- 运单详情 -->
    <waybill-detail
      v-if="detailVisible"
      :detailForm="detailForm"
      :option="detailOption"
      :visible.sync="detailVisible"
    ></waybill-detail>
    </basic-container>
  </div>
</template>

<script>
import {
  queryExcavatorLoadingPage as getPage,
  getObj,
  addObj,
  putObj,
  delObj,
  batchUpdateRemark,
  batchUpdateInPreparePrice,
  exportExcavatorLoadingInfo,
} from "@/api/chain/companywaybill";
import { tableOption } from "@/const/crud/chain/companywaybill3";
import { mapGetters } from "vuex";
import { exportOut } from "@/util/down.js";
import WaybillDetail from "../companywaybill2/detail.vue";
import tags from "./tags.vue";
export default {
  name: "companywaybill3",
  data() {
    return {
      tableKey:0,
      detailVisible:false,
      detailForm: {},
      detailOption: {
        labelPosition: "left",
        detail: true,
        tabs: true,
        // labelWidth: 0,
        group: [
          {
            label: "出场签单",
            prop: "group2",
            column: [
              {
                label: "运单号",
                prop: "no",
                span: 8,
                placeholder: " ",
              },
              {
                label: "创建时间",
                prop: "createDatetime", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "完成时间",
                prop: "completeDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "运单状态",
                prop: "statusName", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目名称",
                prop: "projectName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目负责人",
                prop: "leadingNames", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场签单时间",
                prop: "goDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场签单班次",
                prop: "goShiftTypeName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场签单员",
                prop: "goStaffName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "运输类型",
                prop: "tpModeName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场土质",
                prop: "goSoilType",
                span: 8,
                placeholder: " ",
              },
              {
                label: "地块",
                prop: "goSoilType", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "单位",
                prop: "weightUnit",
                span: 8,
                placeholder: " ",
              },
              {
                label: "单价",
                prop: "unitPrice",
                span: 8,
                placeholder: " ",
              },
              {
                label: "数量",
                prop: "weightTons",
                span: 8,
                placeholder: " ",
              },
              {
                label: "价格",
                prop: "payeePrice",
                span: 8,
                placeholder: " ",
              },
              {
                label: "泥尾",
                prop: "garbageName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "是否需要泥尾票",
                prop: "isTicket", //没有
                span: 8,
                placeholder: " ",
              },

              {
                label: "出场车牌",
                prop: "goDriverTruckCode",
                span: 8,
                placeholder: " ",
              },

              {
                label: "泥尾票号",
                prop: "ticketNo",
                span: 8,
                placeholder: " ",
              },

              {
                label: "泥尾票土质",
                prop: "goTicketSoilType",
                span: 8,
                placeholder: " ",
              },

              {
                label: "泥尾票单价",
                prop: "ticketPrice",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场签单地址",
                prop: "goAddr",
                span: 24,
                placeholder: " ",
              },
              {
                label: "出场签单经纬度", //没有
                prop: "goGps",
                span: 24,
                placeholder: " ",
              },
              {
                label: "卸土签单地址", //没有
                prop: "completeAddr",
                span: 24,
                placeholder: " ",
              },
              {
                label: "卸土签单经纬度", //没有
                prop: "completeGps",
                span: 24,
                placeholder: " ",
              },
              {
                label: "电子结算卡",
                prop: "settleCardNo",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场备注",
                prop: "goRemark",
                span: 12,
                placeholder: " ",
              },

              // {
              //   label: "出口签单车型",
              //   prop: "goVehicleType",
              //   span: 8,
              //   placeholder: " ",
              // },
              {
                label: "图片",
                prop: "picTitle",
                span: 24,
                placeholder: " ",
              },
              {
                label: "出场签单",
                prop: "goPicture1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "出场泥尾票",
                prop: "ticketImg1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "磅单",
                prop: "bd",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "goPicture",
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                style: "display: block !important;",
                span: 8,
                placeholder: " ",
              },

              {
                label: "",
                prop: "ticketImg",
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
              {
                label: "", //没有
                prop: "imgUrl",
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
            ],
          },
          // {
          //   label: "基本信息",
          //   prop: "group",
          //   column: [

          //     {
          //       label: "项目名称",
          //       prop: "projectName",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "项目合作方",
          //       prop: "agentName",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "状态",
          //       prop: "statusName",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "地块",
          //       prop: "landParcel",
          //       span: 24,
          //       placeholder: " ",
          //     },
          //   ],
          // },
          {
            label: "挖机签单",
            prop: "group1",
            column: [
              {
                label: "运单号",
                prop: "no",
                span: 8,
                placeholder: " ",
              },
              {
                label: "创建时间",
                prop: "createDateTime", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "完成时间",
                prop: "completeDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "运单状态",
                prop: "statusName", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目名称",
                prop: "projectName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目负责人",
                prop: "leadingNames", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单时间",
                prop: "inDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单班次",
                prop: "inShiftTypeName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单员",
                prop: "inStaffName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机车主",
                prop: "ownerName", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机车主手机",
                prop: "ownerMobile", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机型号",
                prop: "machineCode", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单土质",
                prop: "inSoilType",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单员",
                prop: "inStaffName",
                span: 8,
                placeholder: " ",
              },

              {
                label: "进量(吨)",
                prop: "load", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "扣量(吨)",
                prop: "cut", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "单位(元/吨)：",
                prop: "inDriverTruckCode",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机签单地址",
                prop: "inAddr",
                span: 24,
                placeholder: " ",
              },
              {
                label: "挖机签单经纬度", //没有
                prop: "inGps",
                span: 16,
                placeholder: " ",
              },
              {
                label: "装车价", //没有
                prop: "inPreparePrice",
                span: 16,
                placeholder: " ",
              },

              {
                label: "凭证类型",
                prop: "inWeightUnit",
                span: 8,
                placeholder: " ",
              },
              {
                label: "挖机备注",
                prop: "inRemark",
                span: 8,
                placeholder: " ",
              },
              {
                label: "PC后台备注",
                prop: "inRemark",
                span: 8,
                placeholder: " ",
              },
              {
                label: "图片",
                prop: "picTitle",
                span: 24,
                placeholder: " ",
              },
              {
                label: "挖机签单",
                prop: "inPicture1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "称重仪器",
                prop: "inWeighInstrumentPicture1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "place",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "inPicture",
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "inWeighInstrumentPicture",
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
            ],
          },

          {
            label: "入场签单",
            prop: "group4",
            column: [
              {
                label: "运单号",
                prop: "no",
                span: 8,
                placeholder: " ",
              },
              {
                label: "创建时间",
                prop: "createDateTime", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "完成时间",
                prop: "completeDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "运单状态",
                prop: "statusName", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目名称",
                prop: "projectName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目负责人",
                prop: "leadingNames", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "blockTitle",
                span: 24,
                placeholder: " ",
              },
              {
                label: "入场签单时间",
                prop: "entranceDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单班次", //没有
                prop: "entranceShiftTime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单员",
                prop: "entranceStaffName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单车牌",
                prop: "entranceTruckCode",
                span: 8,
                placeholder: " ",
              },

              {
                label: "入场签到备注",
                prop: "entranceRemark",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "blockTitle1",
                span: 24,
                placeholder: " ",
              },
              {
                label: "入场签单时间",
                prop: "entranceDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单班次", //没有
                prop: "entranceShiftType",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单员",
                prop: "entranceStaffName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单车牌",
                prop: "entranceTruckCode",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场签单土质", //没有
                prop: "entranceTruckCode",
                span: 8,
                placeholder: " ",
              },
              {
                label: "泥尾票号",
                prop: "backfillTicketNo",
                span: 8,
                placeholder: " ",
                overHidden: true,
              },
              // {
              //   label: "入场签单车牌",
              //   prop: "backfillTruckCode",
              //   span: 8,
              //   placeholder: " ",
              // },
              // {
              //   label: "入场签单土质",
              //   prop: "entranceTruckCode",//没有
              //   span: 8,
              //   placeholder: " ",
              // },

              {
                label: "入场签单备注", // 没有
                prop: "entranceRemark",
                span: 8,
                placeholder: " ",
                overHidden: true,
              },
              {
                label: "图片",
                prop: "picTitle",
                span: 24,
                placeholder: " ",
              },
              {
                label: "入场签单",
                prop: "inPicture1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "入场泥尾票",
                prop: "inWeighInstrumentPicture1",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "place",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "backfillPicUrl", //没有
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
              {
                label: "",
                prop: "backfillTicketNoUrl", //没有
                type: "upload",
                listType: "picture-card",
                dataType: "string",
                span: 8,
                placeholder: " ",
              },
            ],
          },
          {
            label: "司机车辆",
            prop: "group3",
            column: [
              {
                label: "运单号",
                prop: "no",
                span: 8,
                placeholder: " ",
              },
              {
                label: "创建时间",
                prop: "createDateTime", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "完成时间",
                prop: "completeDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "运单状态",
                prop: "statusName", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目名称",
                prop: "projectName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "项目负责人",
                prop: "leadingNames", //没有
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机",
                prop: "driverName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "车牌号",
                prop: "goDriverTruckCode",
                span: 8,
                placeholder: " ",
              },
              {
                label: "行驶车辆车型",
                prop: "brandType",
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机手机",
                prop: "driverMobile",
                span: 8,
                placeholder: " ",
              },
              {
                label: "车队长", //没有
                prop: "captainName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "车队长手机号", //没有
                prop: "captainMobile",
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机出场时间",
                prop: "confirmGoDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机卸土时间",
                prop: "completeDatetime",
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机卸土地址",
                prop: "completeAddr",
                span: 16,
                placeholder: " ",
              },
              {
                label: "直付类型",
                prop: "isPlatformDirectPayName",
                span: 8,
                placeholder: " ",
              },
              {
                label: "司机卸土经纬度", //没有
                prop: "completeGps",
                span: 24,
                placeholder: " ",
              },
            ],
          },
          // {
          //   label: "回填入场签单",
          //   prop: "group5",
          //   column: [
          //     {
          //       label: "回填项目",
          //       prop: "backfillProjectName",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "回填车牌",
          //       prop: "backfillTruckCode",
          //       span: 8,
          //       placeholder: " ",
          //     },

          //     {
          //       label: "备注",
          //       prop: "backfillRemark",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "回填签单人",
          //       prop: "backfillSignName",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "回填签单时间",
          //       prop: "backfillSignDatetime",
          //       span: 8,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "拍照车辆",
          //       prop: "backfillPicUrl",
          //       type: "upload",
          //       listType: "picture-card",
          //       dataType: "string",
          //       span: 24,
          //       placeholder: " ",
          //     },
          //     {
          //       label: "拍照泥尾票",
          //       prop: "backfillTicketNoUrl",
          //       type: "upload",
          //       listType: "picture-card",
          //       dataType: "string",
          //       span: 24,
          //       placeholder: " ",
          //     },
          //   ],
          // },
        ],
      },
      pcRemarkRules: {
        remark: [{ required: true, message: "请输入PC备注", trigger: "blur" }],
      },
      loadingPriceVisible: false,
      loadingPriceForm: {
        price: "",
      },
      loadingPriceRules: {
        price: [{ required: true, message: "请输入装车价", trigger: "blur" }],
      },
      curRowData: {},
      pcRemarkVisible: false,
      pcRemarkForm: {
        remark: "",
      },
      statements: [],
      form: {},
      tableData: [],
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000, 5000],
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: "in_datetime", //降序字段
      },
      paramsSearch: {},
      searchForm: {},
      tableLoading: false,
      tableHeight: "100px",
      tableOption: tableOption,
      marker: null,
      map: null,
      polyline: null,
      speed: 50,
      firstArr: [113.98074, 22.55251],
      lineArr: [
        [121.5389385, 31.21515044],
        [121.5389385, 31.29615044],
        [121.5273285, 31.21515044],
      ],
      searchDom: {},
      btnLoading: false,
      isOne: true,
      search: {
        projectInfoId: "",
        machineCode: "",
        ownerName: "",
      },
      multipleSelection: [],
      isExpand: false,
    };
  },
  components: {
    tags,
    WaybillDetail
  },
  created() {},
  mounted() {
    // this.searchDom = this.$refs.crud.$refs.headerSearch;
    // window.addEventListener("resize", this.func);
  },
  activated() {
    // setTimeout(() => {
    //   let tableHeight = document.querySelector(".el-table").offsetTop;
    //   this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.tableOption.height =
    //     window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.doLayout();
    // }, 100);
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        // addBtn: this.permissions['chain:companywaybill:add'] ? true : false,
        // delBtn: this.permissions['chain:companywaybill:del'] ? true : false,
        // editBtn: this.permissions['chain:companywaybill:edit'] ? true : false,
        viewBtn: this.permissions["chain:companywaybill3:get"] ? true : false,
      };
    },
  },
  watch: {
    // "searchDom.searchShow": {
    //   handler(newVal, oldVal) {
    //     setTimeout(() => {
    //       let tableHeight = document.querySelector(".el-table").offsetTop;
    //       this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
    //       this.$refs.crud.tableOption.height =
    //         window.innerHeight - tableHeight - 182;
    //       this.$refs.crud.doLayout();
    //     }, 300);
    //   },
    //   deep: true,
    // },
  },
  mounted: function () {
    this.updateTableHeight(); // 页面加载时计算一次高度
    window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    viewInfo(row, index) {
      this.tableLoading = true;
      getObj(row.id)
        .then((res) => {
          this.tableLoading = false;
          this.detailForm = res.data.data;
          this.detailForm.ticketNo =
            this.detailForm.ticketNo &&
            this.detailForm.manualSelectTicket == "0"
              ? `${this.detailForm.ticketNo}(系统分配)`
              : this.detailForm.ticketNo || "";
          this.detailVisible = true;
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    expandSearch() {
      this.$refs.crud.$refs.headerSearch.show =
        !this.$refs.crud.$refs.headerSearch.show;
      this.isExpand = this.$refs.crud.$refs.headerSearch.show;
      this.$nextTick(() => {
        this.$refs.crud.resizeFunc();
      });
    },
    changeAll(e) {
      if (e) {
        this.$refs.crud.$refs.table.toggleAllSelection();
      } else {
        this.multipleSelection = [];
        this.$refs.crud.$refs.table.clearSelection();
      }
    },
    batchUpdateInPreparePrice(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = {
            ids: this.curRowData
              ? [this.curRowData.id]
              : this.multipleSelection.map((item) => item.id),
            inPreparePrice: this.loadingPriceForm.price,
          };
          batchUpdateInPreparePrice(arr).then((res) => {
            this.$message.success("操作成功");
            this.loadingPriceVisible = false;
            this.loadingPriceForm.price = "";
            this.getPage(this.page);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    batchSetLoadCarPrice(row) {
      this.curRowData = row;
      this.loadingPriceVisible = true;
      //   this.$prompt("设置装车价", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputType: "number",
      //     // inputPattern:/^[0-9]+(\.[0-9]{1,2})?$/,
      //     inputPlaceholder: "请设置装车价",
      //     inputValidator: (value) => {
      //       if (!value) {
      //         return "装车价不能为空";
      //       } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
      //         return "请输入两位小数";
      //       }
      //     },
      //     // inputErrorMessage: "请输入装车价",
      //   })
      //     .then(({ value }) => {
      //       let data = {};
      //       if (row.id) {
      //         data = {
      //           inPreparePrice: value,
      //           ids: [row.id],
      //         };
      //       } else {
      //         data = {
      //           inPreparePrice: value,
      //           ids: this.multipleSelection.map((v) => v.id),
      //         };
      //       }

      //       this.batchUpdateInPreparePrice(data);
      //     })
      //     .catch(() => {});
    },
    exportOut,
    // func() {
    //   let tableHeight = document.querySelector(".el-table").offsetTop;
    //   this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.tableOption.height =
    //     window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.doLayout();
    // },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      console.log(this.paramsSearch);
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params = {}) {
      this.tableLoading = true;
      //第一次调用
      console.log(params);
      if (this.isOne && this.$route.query.info) {
        let info = JSON.parse(this.$route.query.info);
        this.search.projectInfoId = info.projectInfoId;
        this.search.machineCode = info.machineCode;
        this.search.ownerName = info.ownerName;
        this.search.shiftName = info.shiftName;
        this.search.inStaffName = info.inStaffName;
        this.search.goDatetimeStart = info.goDatetimeStart;
        this.search.goDatetimeEnd = info.goDatetimeEnd;
        this.search.status = info.status;
        if (info.goDatetimeStart) {
          this.search.goDatetime = [info.goDatetimeStart, info.goDatetimeEnd];
        }
      }
      Object.assign(params, this.search);
      if (params) {
        if (params.hasOwnProperty("inDatetime")) {
          params.inDatetimeStart = params.inDatetime[0];
          params.inDatetimeEnd = params.inDatetime[1];
          delete params.inDatetime;
        }
        if (params.hasOwnProperty("goDatetime")) {
          params.goDatetimeStart = params.goDatetime[0];
          params.goDatetimeEnd = params.goDatetime[1];
          delete params.goDatetime;
        }
        if (params.hasOwnProperty("inShiftTime")) {
          params.inShiftTimeStart = params.inShiftTime[0];
          params.inShiftTimeEnd = params.inShiftTime[1];
          delete params.inShiftTime;
        }
        if (params.hasOwnProperty("goShiftTime")) {
          params.goShiftTimeStart = params.goShiftTime[0];
          params.goShiftTimeEnd = params.goShiftTime[1];
          delete params.goShiftTime;
        }
      }
      if (this.statements.length > 0) {
        params.settleCardNo = this.statements.join(",");
      }
      getPage(
        this.filterForm(
          Object.assign(
            {
              current: page.currentPage,
              size: page.pageSize,
              descs: this.page.descs,
              ascs: this.page.ascs,
              pageRoute: "companywaybill3",
            },
            params,
            this.paramsSearch
          )
        )
      )
        .then((response) => {
          this.isOne = false;
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.isOne = false;
          this.tableData = [];
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    filterImg(imgUrl) {
      let url = null;
      if (!!imgUrl && imgUrl != "") {
        url = imgUrl.split(",");
      }
      return url == null ? null : url[0];
    },
    filterImgs(imgUrl) {
      let url = null;
      if (!!imgUrl && imgUrl != "") {
        url = imgUrl.split(",");
      }
      return url == null ? [] : url;
    },
    exOut(value) {
      this.$router.push({ path: "/exportExc/exportExc" });
    },
    exOutExcel() {
      let params = this.filterForm(
        Object.assign(
          { descs: this.page.descs, ascs: this.page.ascs },
          this.paramsSearch,
          this.search
        )
      );
      this.getPage(this.page);

      if (params) {
        if (params.hasOwnProperty("inDatetime")) {
          params.inDatetimeStart = params.inDatetime[0];
          params.inDatetimeEnd = params.inDatetime[1];
          delete params.inDatetime;
        }
        if (params.hasOwnProperty("goDatetime")) {
          params.goDatetimeStart = params.goDatetime[0];
          params.goDatetimeEnd = params.goDatetime[1];
          delete params.goDatetime;
        }
        if (params.hasOwnProperty("inShiftTime")) {
          params.inShiftTimeStart = params.inShiftTime[0];
          params.inShiftTimeEnd = params.inShiftTime[1];
          delete params.inShiftTime;
        }
        if (params.hasOwnProperty("goShiftTime")) {
          params.goShiftTimeStart = params.goShiftTime[0];
          params.goShiftTimeEnd = params.goShiftTime[1];
          delete params.goShiftTime;
        }
      }
      for (const key in params) {
        if (key.includes("$") || params[key] == undefined) {
          delete params[key];
        }
      }
      params.pageRoute = "companywaybill3";
      let url = "/chain/companywaybill/exportExcavatorLoadingInfo";
      if (this.page.total > 50000) {
        this.$confirm(
          "导出数据量太大,有可能导出失败,建议按条件查询分批导出,是否继续？",
          "提示",
          {
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.exCel(params, url);
          })
          .catch(() => {});
      } else {
        this.exCel(params, url);
      }
    },
    exCel(params, url) {
      this.btnLoading = true;
      exportExcavatorLoadingInfo(params)
        .then((res) => {
          this.btnLoading = false;
          this.$store.commit("SET_DOWN_EXCEL_SHOW", true);
        })
        .catch((err) => {
          this.$message.error("导出失败");
          this.btnLoading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchSetRemark() {
      // let arr = this.multipleSelection.map((item) => item.id);
      //     let obj = {
      //       remark: value,
      //       ids: arr,
      //     };
      //     this.editPcRemark(obj);
      // this.$prompt("PC后台备注", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPlaceholder: "请输入PC后台备注",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "PC后台备注不能为空";
      //     }
      //   },
      //   inputErrorMessage: "请输入PC后台备注",
      // })
      //   .then(({ value }) => {
      //   })
      //   .catch(() => {});
    },
    setRemark(row) {
      this.curRowData = row;
      this.pcRemarkVisible = true;
      // this.$prompt("PC后台备注", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPlaceholder: "请输入PC后台备注",
      //   inputValue: row.inPcRemark || "",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "PC后台备注不能为空";
      //     }
      //   },
      //   inputErrorMessage: "请输入PC后台备注",
      // })
      //   .then(({ value }) => {
      //     this.editPcRemark({
      //       ids: [row.id],
      //       remark: value,
      //     });
      //   })
      //   .catch(() => {});
    },
    editPcRemark(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = {
            ids: this.curRowData
              ? [this.curRowData.id]
              : this.multipleSelection.map((item) => item.id),
            remark: this.pcRemarkForm.remark,
          };
          batchUpdateRemark(arr).then((res) => {
            this.$message.success("操作成功");
            this.pcRemarkVisible = false;
            this.pcRemarkForm.remark = "";
            this.getPage(this.page);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  destroyed() {
    // window.removeEventListener("resize", this.func);
  },
};
</script>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
<style lang="scss" scoped>
.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .tag {
    margin-right: 10px;
  }
}
.input-card {
  position: absolute;
  right: 40px;
  bottom: 40px;
  background-color: #fff;
  padding: 10px;
  .my-row {
    margin-top: 15px;
  }
}
/deep/ .amap-marker-label {
  background: rgba(0, 0, 0, 0.4);
}
/deep/.left-label {
  padding: 2px;
  display: flex;
  align-items: center;
  color: #ffff;
}

/deep/ .left-label img {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}
</style>
<style lang="scss" scoped>
@import "@/styles/newPage.scss";
/deep/.headerContent {
  margin-left: 95px;
}
/deep/.headerContent ~ .el-button {
  display: none;
}
/deep/.avue-crud__tip {
  display: none;
}
</style>